export type ExportFormat = 'horizontal' | 'vertical';
export type PreviewAspect = 'landscape' | 'portrait';

/**
 * Export the format the user is currently looking at, so clicking Export never
 * asks. Falls back to whatever IS available if the previewed orientation
 * cannot be exported (e.g. a vertical-only source while the preview is
 * clamped), and to the previewed format when the list is empty (the formats
 * are probed asynchronously from the video, so the list can be momentarily
 * unknown).
 */
export function resolveExportFormat(
  { previewAspect, availableFormats }: {
    previewAspect: PreviewAspect;
    availableFormats: ExportFormat[];
  },
): ExportFormat {
  const desired: ExportFormat = previewAspect === 'portrait' ? 'vertical' : 'horizontal';
  if (availableFormats.length === 0) return desired;
  return availableFormats.includes(desired) ? desired : availableFormats[0];
}
